const iframe = code => {
  return `<iframe id="iDalgo-Barometer" src="${process.env.FRONT_URL}/${code}" style="width: 100%; height: 450px;" frameborder="0" scrolling="no"></iframe><script type="text/javascript">window.addEventListener("message",function(e){e.data.height&&(document.getElementById("iDalgo-Barometer").style.height=e.data.height+"px")});</script>`
}

const iframeBundle = code => {
  return `<script src="${process.env.IFRAME_BUNDLE}" id="iDalgo-player-list" data-key="${code}" async></script>`
}

export {
  iframe,
  iframeBundle
}



// WEBPACK FOOTER //
// ./src/services/generators.js